import { FC } from 'react'

import styled from 'styled-components'
import { Skeleton } from '@mantine/core'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
`

export const TableLoading: FC = () => {
  return (
    <Container>
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
      <Skeleton height={60} width='100%' />
    </Container>
  )
}
